import {mapState} from 'vuex'
import store from "./store";

Vue.mixin({
    computed: {
        ...mapState(['list']),
        ...mapState(['project']),
        ...mapState(['favoritesIds']),
        ...mapState(['confirmDeleteFavorite']),
        ...mapState(['deleteFavoriteId']),
        ...mapState(['application']),

        documentHeight() {
            return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
        },
        windowHeight() {
            return window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight
        },
        windowWidth() {
            return window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth
        },
    },
    methods: {
        trans(key, lang) {
            if (lang) {
                return _.get(window.trans, lang)
            }
            return _.get(window.trans, key, key)
        },
        setFavoritesIds() {
            this.$store.dispatch('loadFavoritesIds')
        },
        addToFavorites(id) {
            if (this.mode === 'proposal') {
                let rule_id = _.find(this.application.roles[this.project].models, {'ID_Model': id}).ID_Voorstelregel
                this.setHeart(rule_id, id, 1)
            } else {
                let storage = localStorage.getItem('favorites_' + this.project);
                let ids = storage ? JSON.parse(storage) : []
                ids.push(id)
                localStorage.setItem('favorites_' + this.project, JSON.stringify(ids));
                this.setFavoritesIds()
                setTimeout(function () {
                    this.$store.dispatch('loadFavorites', JSON.stringify(ids))
                }.bind(this), 200);
                setTimeout(function () {
                    this.$store.dispatch('forceReloadFavorites')
                }.bind(this), 400);

            }
        },
        removeFromFavorites(id, force) {
            console.log(id)
            this.$store.dispatch('setDeleteFavoriteId', id)
            if (!this.confirmDeleteFavorite || force) {
                this.doRemoveFromFavorites()
            } else {
                this.$store.dispatch('showConfirmDeleteFavorite', true)
            }
            if (this.mode === 'proposal') {
                let rule_id = _.find(this.application.roles[this.project].models, {'ID_Model': id}).ID_Voorstelregel
                this.setHeart(rule_id, id, 0)
            }
        },
        doRemoveFromFavorites() {
            if (this.mode !== 'talents' && this.mode !== 'proposal') {
                this.$store.dispatch('forceHidePreview')
            }
            if (this.mode === 'applicationFinish' || this.mode === 'proposal') {
                let rule_id = _.find(this.application.roles[this.project].models, {'ID_Model': this.deleteFavoriteId}).ID_Voorstelregel
                this.setHeart(rule_id, this.deleteFavoriteId, 0)
                if (this.mode === 'applicationFinish'){

                }
            } else {
                let storage = localStorage.getItem('favorites_' + this.project);
                let ids = storage ? JSON.parse(storage) : []
                let index = ids.indexOf(this.deleteFavoriteId)
                ids.splice(index, 1)
                localStorage.setItem('favorites_' + this.project, JSON.stringify(ids));
                this.setFavoritesIds()
                setTimeout(function () {
                    this.$store.dispatch('loadFavorites', JSON.stringify(ids))
                }.bind(this), 200);

            }
            this.$store.dispatch('setDeleteFavoriteId', 0)
        },
        removeAllFromFavorites() {
            localStorage.removeItem('favorites_' + this.project);
            this.setFavoritesIds()
            setTimeout(function () {
                this.$store.dispatch('loadFavorites', this.favoritesIds[this.project])
                setTimeout(function () {
                    document.location = "/"
                }, 100)
            }.bind(this), 200);
        },
        setHeart(rule_id, model_id, value) {
            value = value ? value : 0
            let data = {rule_id: rule_id, value: value, proposalId: this.project, model_id:model_id}
            axios.post('/proposal/set-heart', data)
            this.$store.dispatch('setHeart', data)
        },
        firstFoto(model) {
            if (model.fotos[0]) {
                let id = model.fotos[0].ID_Foto
                return '/models/' + id
            }
            return ''
        },
        isFavorite(id) {
            let type = typeof this.favoritesIds[this.project]
            if (type !== 'undefined') {
                if (this.mode === 'applicationFinish' || this.mode === 'proposal') {
                    return this.application.roles[this.project].models[id].favorite == "1"
                } else {
                    return _.indexOf(this.favoritesIds[this.project], id) > -1
                }
            } else {
                return false
            }
        },
        fetchApplication(applicationId) {
            this.$store.dispatch('getApplication', applicationId)
        },
        fetchProposal(applicationId, proposalId) {
            this.$store.dispatch('getProposal', {applicationId: applicationId, proposalId: proposalId})
        },
        formatDate(date) {
            date = date ? date.replace(" ", ' | ').replace(/\//g, '-') : ''
            date = date.split("-");
            date = date[1] + "-" + date[0] + "-" + date[2]
            return date.slice(0, -3);
        },
    }
})
